import classNames from "classnames";
import { observer } from "mobx-react-lite";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { TextType } from "../../../app/helpers/zwibblerHelper";
import { translationHookOptions } from "../../../app/localization/localization";
import { RootStoreContext } from "../../../app/stores/rootStore";
import ColorSettingTool from "../../common/ColorSettingTool";

const PreferenzeButton = () => {
  const rootStore = useContext(RootStoreContext);
  const { theme, toolbar } = rootStore.commonStore;
  const {
    setBrushConfigColor,
    setBrushConfigLine,
    ZwibblerSetTextDimension,
    ZwibblerSetTextFont,
    ZwibblerSetTextType,
    toolConfig,
  } = rootStore.zwibblerStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  const [preferenzeDropdownOpen, setPreferenzeDropdownOpen] = useState(false);
  const togglePreferenze = () =>
    setPreferenzeDropdownOpen(!preferenzeDropdownOpen);

  if (!toolbar) return <></>;
  const { tools } = toolbar;
  return (
    <>
      <ButtonDropdown
        isOpen={preferenzeDropdownOpen}
        toggle={togglePreferenze}
        className={classNames(" transparentButton dropdownButton dropdownDiv")}
      >
        <DropdownToggle
          color="none"
          className={classNames(
            " transparentButton dropdownButton",
            `${theme!.toolbarIconColor}`
          )}
        >
          <i className="fas fa-cog iconToolbarButton"></i>
          <h6 className="textToolbarButton mb-0">
            {t("toolbar_settings_panel_title")}
          </h6>
        </DropdownToggle>
        <DropdownMenu className="preferenzeDropdownMenu">
            <ColorSettingTool/>
          {tools.text && (
            <div className="row ml-1 mt-2">
              <div className="col-4">
                <div>{t("toolbar_settings_font_label")}</div>
                <select
                  className="preferenzeDropdown"
                  onChange={(event) => ZwibblerSetTextFont(event.target.value)}
                  defaultValue={toolConfig.font}
                >
                  {/* <option>Alice</option> */}
                  <option value={"Arial"}>Arial</option>
                  <option value={"Times New Roman"}>Times New Roman</option>
                  <option value={"Courier New"}>Courier New</option>
                  {/* <option>Pacifico</option>
                <option>Anton</option>
                <option>Bebas Neue</option>
                <option>Bitter</option>
                <option>East Sea Dokdo</option>
                <option>Goldman</option>
                <option>Hanalei Fill</option>
                <option>Kufam</option>
                <option>Lustria</option>
                <option>Pirata One</option>
                <option>Poppins</option>
                <option>Raleway</option>
                <option>Redressed</option>
                <option>Roboto Condensed</option>
                <option>Slabo 27px</option>
                <option>Spectral</option>
                <option>Spectral SC</option>
              <option>Yeon Sung</option> */}
                </select>
              </div>
              <div className="col-4">
                <div>{t("toolbar_settings_style_label")}</div>
                <select
                  className="preferenzeDropdown"
                  onChange={(event) => ZwibblerSetTextType(event.target.value)}
                  defaultValue={toolConfig.style}
                >
                  <option value={TextType.Normal}>
                    {t("toolbar_settings_normal_style_option")}
                  </option>
                  <option value={TextType.Bold}>
                    {t("toolbar_settings_bold_style_option")}
                  </option>
                  {/* <option value={TextType.Italic.toString()}>{t("toolbar_settings_italic_style_option")}</option> */}
                </select>
              </div>
              <div className="col-4">
                <div>{t("toolbar_settings_font_size_label")}</div>
                <select
                  className="preferenzeDropdown"
                  onChange={(event) =>
                    ZwibblerSetTextDimension(parseInt(event.target.value))
                  }
                  defaultValue={toolConfig.size}
                >
                  <option value={8}>8</option>
                  <option value={10}>10</option>
                  <option value={12}>12</option>
                  <option value={20}>20</option>
                  <option value={24}>24</option>
                  <option value={50}>50</option>
                  <option value={60}>60</option>
                  <option value={70}>70</option>
                  <option value={80}>80</option>
                  <option value={90}>90</option>
                  <option value={100}>100</option>
                </select>
              </div>
            </div>
          )}
        </DropdownMenu>
      </ButtonDropdown>
    </>
  );
};

export default observer(PreferenzeButton);
